import React, { useEffect, useState } from "react";
import { updateBankDetails } from "../../../apis/customers";
import { successAlert } from "../../../style/scss/utils/Alerts";

const EMandate = ({ customerData }) => {
    const user = customerData?.allData;
    const userData = JSON.parse(sessionStorage.getItem("info"));

    const [formData, setFormData] = useState({
        bankName: "",
        bankAccountNo: "",
        ifscCode: "",
        accountHolderName: "",
        accountType: "savings",
        customerPhone: "",
        customerEmail: "",
        mandateType: "netbanking",
        maxAmount: "",
        frequency: "monthly",
        startDate: "",
        endDate: "",
        consent: false,
    });

    useEffect(() => {
        if (user) {
            setFormData(prev => ({
                ...prev,
                bankName: user.bankName || "",
                bankAccountNo: user.bankAccountNo || "",
                ifscCode: user.ifscCode || "",
                accountHolderName: user.accountHolderName || "",
                customerPhone: user.phone || "",
                customerEmail: user.email || "",
            }));
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async () => {
        try {
            // const res = await updateBankDetails({
            //     userId: user.id,
            //     ...formData,
            // });
            // if (res.data.status === true) {
            successAlert("Success", "Details Successfully Updated");
            // }
        } catch (error) {
            console.error("Update failed:", error);
            successAlert("Error", "Update Failed");
        }
    };

    const isFormBlank =
        !formData.bankName && !formData.bankAccountNo && !formData.ifscCode;

    const shouldShowSaveButton =
        userData?.type === "financer" || isFormBlank;

    return (
        <div className="modal fade" id="e-mandate">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3>E-Mandate Details</h3>
                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i className="ti ti-x" />
                        </button>
                    </div>
                    <div className="modal-body">
                        {user && (
                            <div className="row">
                                {/* Basic Info */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Bank Name</label>
                                    <input type="text" className="form-control" name="bankName" value={formData.bankName} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Account Number</label>
                                    <input type="text" className="form-control" name="bankAccountNo" value={formData.bankAccountNo} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">IFSC Code</label>
                                    <input type="text" className="form-control" name="ifscCode" value={formData.ifscCode} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>

                                {/* Razorpay Specific */}
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Account Holder Name</label>
                                    <input type="text" className="form-control" name="accountHolderName" value={formData.accountHolderName} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Account Type</label>
                                    <select className="form-select" name="accountType" value={formData.accountType} onChange={handleChange} disabled={!shouldShowSaveButton}>
                                        <option value="savings">Savings</option>
                                        <option value="current">Current</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Phone Number</label>
                                    <input type="text" className="form-control" name="customerPhone" value={formData.customerPhone} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Email Address</label>
                                    <input type="email" className="form-control" name="customerEmail" value={formData.customerEmail} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Mandate Type</label>
                                    <select className="form-select" name="mandateType" value={formData.mandateType} onChange={handleChange} disabled={!shouldShowSaveButton}>
                                        <option value="netbanking">Net Banking</option>
                                        <option value="debit_card">Debit Card</option>
                                        <option value="nach">NACH</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Max Amount</label>
                                    <input type="number" className="form-control" name="maxAmount" value={formData.maxAmount} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Frequency</label>
                                    <select className="form-select" name="frequency" value={formData.frequency} onChange={handleChange} disabled={!shouldShowSaveButton}>
                                        <option value="monthly">Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="yearly">Yearly</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Start Date</label>
                                    <input type="date" className="form-control" name="startDate" value={formData.startDate} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">End Date</label>
                                    <input type="date" className="form-control" name="endDate" value={formData.endDate} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                </div>

                                {/* Consent */}
                                <div className="col-md-12 mb-3">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="consent" checked={formData.consent} onChange={handleChange} disabled={!shouldShowSaveButton} />
                                        <label className="form-check-label">
                                            I authorize and give consent to initiate mandate setup.
                                        </label>
                                    </div>
                                </div>

                                {shouldShowSaveButton && (
                                    <div className="col-md-12 text-end">
                                        <button className="btn btn-primary" onClick={handleSubmit}>
                                            Update
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EMandate;
